import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import getFirebaseToken from './getFirebaseCookieToken';
import signInWithCustomToken from './signInWithCustomToken';
export default function loginWithFirebaseToken(_x) {
  return _loginWithFirebaseToken.apply(this, arguments);
}

function _loginWithFirebaseToken() {
  _loginWithFirebaseToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(app) {
    var firebaseToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            firebaseToken = getFirebaseToken();

            if (!firebaseToken) {
              _context.next = 5;
              break;
            }

            _context.next = 4;
            return signInWithCustomToken({
              app: app,
              firebaseToken: firebaseToken
            });

          case 4:
            return _context.abrupt("return", true);

          case 5:
            return _context.abrupt("return", false);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loginWithFirebaseToken.apply(this, arguments);
}